import React from 'react';
import Box from '@mui/material/Box';

export default function ThemeFigcaption({figcaptionText}) {

    if(!figcaptionText) {
        return null;
    }

    return (
        <Box sx={(theme) => ({
        maxWidth:"650px",
        backgroundColor: "#ffffff",
        color: "#020617",
        fontSize: "0.875rem",
        padding: "5px 16px",
        margin: "0 auto",
        textAlign: "center",
        borderRadius: "3px",
        boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)",
        [theme.breakpoints.down('sm')]:{
            width:"100%",
            maxWidth:"100%",
            boxShadow:"unset",
            borderRadius:"0",
            padding:"5px 12px"
        }
        })}>
            <figcaption>{figcaptionText}</figcaption>
        </Box>
    )
}